import { render } from "./ShowAppointmentDoctor.vue?vue&type=template&id=6471db6e&scoped=true"
import script from "./ShowAppointmentDoctor.vue?vue&type=script&lang=js"
export * from "./ShowAppointmentDoctor.vue?vue&type=script&lang=js"

import "./ShowAppointmentDoctor.vue?vue&type=style&index=0&id=6471db6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6471db6e"]])

export default __exports__